export default __webpack_public_path__ + "static/char-31-0e70f7a778f8229206f9635fe00f2561.webp";